var $ = jQuery.noConflict();

$(window).on("load", function () {
  let method = "front";
  if ($("body").hasClass("wp-admin")) method = "wp-admin";

  var initializeBlock = function ($block) {
    const hero = $(".block-stage");

    const btnScrollDown = $(".fz-button-circle--scroll-down");
    btnScrollDown.on("click", function (e) {
      e.preventDefault();
      if (hero.next().length > 0) {
        let top = hero.next().offset().top;
        if (
          hero.next().hasClass("block-sticky-sections") &&
          $(window).width() > 767
        ) {
          top = hero.next().offset().top + 150;
        }
        $("html, body").animate({ scrollTop: top }, 500);
      }
    });

    if (
      hero.hasClass("block-stage--light-green") ||
      hero.hasClass("block-stage--yellow") ||
      hero.hasClass("block-stage--blue")
    ) {
      $(".page-header").addClass("page-header--dark");
    }
  };

  window.onload = (function () {
    initializeBlock($(this));
  })();

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=rq-stage", initializeBlock);
  }
});
